import { render, staticRenderFns } from "./FilesSidebarTabApp.vue?vue&type=template&id=5d8bc5b4&scoped=true&"
import script from "./FilesSidebarTabApp.vue?vue&type=script&lang=js&"
export * from "./FilesSidebarTabApp.vue?vue&type=script&lang=js&"
import style0 from "./FilesSidebarTabApp.vue?vue&type=style&index=0&id=5d8bc5b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8bc5b4",
  null
  
)

export default component.exports